import { getIconBackgroundImage } from 'styles/utils';
import { spacing } from 'styles/spacing';
import { DefaultTheme } from 'styled-components/dist/types';
/**
These styles refer to the Display sections inside flowable design
The components customized in this file are:
- Alert
- Divider
*/
export const getFlowableAlertStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
  .flw__alert.flw__component {
    ${theme.radii.radius12};
    padding-left: 45px;
    padding-top: 20px;
  }
  .flw__alert__close-icon.flw__component__close-icon {
    ${getIconBackgroundImage('icn_close', theme.color.feedback_notification.info.font, 20, 20)};
    width: 20px;
    height: 20px;
    opacity: 1;
  }
  
  // ERROR ALERT
  .flw__alert.flw__component.flw__alert--error.flw__component--error {
    background: ${theme.color.feedback_notification.error.background};
  }
  .flw__component--error__default-icon {
    width: 20px;
    height: 20px;
    ${getIconBackgroundImage('icn_warning', theme.color.feedback_notification.error.icon, 20, 20)}
  }
  .flw__alert__title.flw__alert--error__title.flw__component--error__title {
    font-size: 16px;
    font-weight: bold;
    color: ${theme.color.feedback_notification.error.font};
    margin-bottom: 0px;
  }
  .flw__alert__body.flw__alert--error__body.flw__component--error__body {
    font-size: 16px;
    color: ${theme.color.feedback_notification.error.font};
  }
  
  // WARNING ALERT
  .flw__alert.flw__component.flw__alert--warning.flw__component--warning {
    background: ${theme.color.feedback_notification.warning.background};
  }
  .flw__component--warning__default-icon {
    width: 20px;
    height: 20px;
    ${getIconBackgroundImage('icn_warning_circle', theme.color.feedback_notification.warning.icon, 20, 20)}
  }
  .flw__alert__title.flw__alert--warning__title.flw__component--warning__title {
    font-size: 16px;
    font-weight: bold;
    color: ${theme.color.feedback_notification.warning.font};
    margin-bottom: 0px;
  }
  .flw__alert__body.flw__alert--warning__body.flw__component--warning__body {
    font-size: 16px;
    color: ${theme.color.feedback_notification.warning.font};
  }
  
  // SUCCESS ALERT
  .flw__alert.flw__component.flw__alert--success.flw__component--success {
    background: ${theme.color.feedback_notification.success.background};
  }
  .flw__component--success__default-icon {
    width: 20px;
    height: 20px;
    ${getIconBackgroundImage('icn_check_circle', theme.color.feedback_notification.success.icon, 20, 20)}
  }
  .flw__alert__title.flw__alert--success__title.flw__component--success__title {
    font-size: 16px;
    font-weight: bold;
    color: ${theme.color.feedback_notification.success.font};
    margin-bottom: 0px;
  }
  .flw__alert__body.flw__alert--success__body.flw__component--success__body {
    font-size: 16px;
    color: ${theme.color.feedback_notification.success.font};
  }
  
  // INFO ALERT
  .flw__alert.flw__component.flw__alert--info.flw__component--info {
    background: ${theme.color.feedback_notification.info.background};
  }
  .flw__alert.flw__component .flw__alert__text-content.flw__component__text-content {
    color: ${theme.color.feedback_notification.info.font};
  }
  .flw__alert--info__default-icon {
    ${getIconBackgroundImage('icn_info', theme.color.feedback_notification.info.icon, 20, 20)}
  }
    .flw__alert__title.flw__alert--info__title.flw__component--info__title {
    font-size: 16px;
    font-weight: bold;
    color: ${theme.color.feedback_notification.info.font};
    margin-bottom: 0px;
  }
  .flw__alert__body.flw__alert--info__body.flw__component--info__body {
    font-size: 16px;
    color: ${theme.color.feedback_notification.info.font};
  }
  `
}

export const getFlowableDividerStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
    .flw__hr {
      width: 100%;
      height: 1px;
      background-color: ${theme.color.general.dividers};
    }
  `
}

export const getFlowableTablesStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
    // TABLE ACTIONS
    // settings
    .flw__data-table__top__header--right span.clear-sort-columns:after, .flw__data-table__top__header--right span.sort-columns:after {
      display:none;
    }
    // filter
    .flw__data-table__top__header--right span.show-filters:after,
    .flw__data-table__top__header--right span.clear-filters:after {
      ${getIconBackgroundImage('icn_filter', theme.color.link.default, 20, 20)};
      width: 20px;
      height: 20px;
    }
    // star
    .flw__data-table__top__header--right span.favorites {
      display: none;
    }
    // Refresh data
    .flw__data-table__top__header--right span.refresh-data:after {
       ${getIconBackgroundImage('icn_sync', theme.color.link.default, 20, 20)};
      width: 20px;
      height: 20px;
    }
    // Refreshing data
    .flw__data-table__top__header--right span.refreshing-data:after {
       ${getIconBackgroundImage('icn_sync', theme.color.link.default, 20, 20)};
      width: 20px;
      height: 20px;
    }
    // Export data
    .flw__data-table__top__header--right span.export-data:after {
       ${getIconBackgroundImage('icn_download', theme.color.link.default, 20, 20)};
      width: 20px;
      height: 20px;
    }
    // dropdowns
    .flw__data-table__top__header--right div.sort-columns-menu ul {
      padding: 0px;  
    }
    .flw__data-table__top__header--right div.favorites-menu, .flw__data-table__top__header--right div.sort-columns-menu {
      ${theme.shadows[3]};
      background-color: ${theme.color.containers.shadowed.background};
      ${theme.radii.radius12};
      min-width: auto;
    }
    .flw__data-table__top__header--right div.sort-columns-menu ul li div.sort-column-label:before {
      ${getIconBackgroundImage('icn_dragger', theme.color.link.default, 20, 20)};
      ${spacing('mr', 2)};
      width: 18px;
      height: 14px;
    }
    .flw__data-table__top__header--right div.favorites-menu>div.reset:before {
      ${getIconBackgroundImage('icn_redo', theme.color.link.default, 20, 20)};
      ${spacing('mr', 2)};
    }
    .flw__data-table__top__header--right div.favorites-menu>div.manage:before {
      ${getIconBackgroundImage('icn_star', theme.color.link.default, 20, 20)};
      ${spacing('mr', 2)};
    }
   .flw__data-table__top__header--right div.favorites-menu>div, 
   .flw__data-table__top__header--right div.sort-columns-menu ul li {
      border: none;
      min-height: 24px;
      display: flex;
      align-items: center;
      color: ${theme.color.general.font.primary};
      font-size: 16px;
      font-weight: 400;
      padding: 0px;
    }
    .flw__data-table__top__header--right div.favorites-menu>div:not(:last-child), 
    .flw__data-table__top__header--right div.sort-columns-menu ul li:not(:last-child){
      ${spacing('mb', 4)};
    }
    .flw__data-table__top__header--right div.favorites-menu, 
    .flw__data-table__top__header--right div.sort-columns-menu {
      ${spacing('py', 4)};
      ${spacing('px', 5)};
    }
    .flw__data-table__top__header--right .no-favorites span {
      margin-left: 0px;
    }
    .flw__data-table__top__header--right div.favorites-menu>div.favorite-list {
      align-items: flex-start;
      color: ${theme.color.general.font.secondary};
    }
    
    // LOADING 
    .flw__data-table .ReactTable .-loading.-active {
      background-color: ${theme.table.header.background};
    }
    .flw-loading-bar:before, .flw__data-table .-loading:before {
      background-color: ${theme.color.progress_and_loading.main};
    }
    
    // HEADER
    .flw__data-table .ReactTable .rt-thead {
      background-color: ${theme.table.header.background};
      border: none;
      ${theme.radii.radius8};
    }
    .flw__data-table .ReactTable .rt-thead.-filters {
      ${theme.radii.radius8};
    }
    .flw__data-table .ReactTable .rt-thead .flw__data-table__header {
      color: ${theme.table.header.label};
      font-weight: 600;
      line-height: 20px;
      ${spacing('py', 1)}
    }
    .flw__data-table .ReactTable .rt-thead .flw__data-table__header .flw__data-table__header__sortable:hover {
      color: ${theme.table.header.label};
      font-weight: 600;
      line-height: 20px;
    }
    
    // HEADER ICONS
    .flw__data-table .ReactTable .rt-thead .flw__data-table__header .flw__data-table__header__sortable:after {
       ${getIconBackgroundImage('icn_face_out_chevron', theme.table.header.label, 18, 18)};
       width: 18px;
       height: 14px;
       opacity: 0.5;
    }
    .flw__data-table .ReactTable .rt-thead .flw__data-table__header.-sort-asc .flw__data-table__header__sortable:after {
      ${getIconBackgroundImage('icn_double_down_chevron', theme.table.header.label, 18, 18)};
      width: 18px;
      height: 14px;
    }
    
    .flw__data-table .ReactTable .rt-thead .flw__data-table__header.-sort-desc .flw__data-table__header__sortable:after {
      ${getIconBackgroundImage('icn_double_up_chevron', theme.table.header.label, 18, 18)};
      width: 18px;
      height: 14px;
    }
    
    // FILTER INPUTS
    .flw__data-table .ReactTable .rt-thead.-filters {
      margin-top: -13px;  
    }
    
    .flw__data-table .ReactTable .rt-thead.-filters input, 
    .flw__data-table .ReactTable .rt-thead.-filters select {
      background: ${theme.table.header.text_field.background};
      border-color: ${theme.table.header.text_field.border};
      color: ${theme.table.header.text_field.font};
      ${spacing('mt', 4)}
      ${theme.radii.radius8};
    }
    
    // EMPTY BDOY
    .flw__data-table--no-footer.flw__data-table--infinite-scroll .ReactTable .rt-noData,
    .flw__data-table .ReactTable .-loading, 
    .flw__data-table .ReactTable .rt-noData,
    .flw__data-table--no-footer .ReactTable .rt-noData {
      color: ${theme.color.general.font.quaternary};
      border-color: ${theme.color.general.dividers};
      background: none;
      border-left: none;
      border-right: none;
    }
    
    // BODY
    .flw__data-table .ReactTable {
      border: none;
    }
    
    .flw__data-table .ReactTable .rt-tbody {
      ${spacing('mt', 2)}
      border-left: 0;
    }
    .flw__data-table .ReactTable .rt-tbody .rt-tr-group {
      border-color: ${theme.color.general.dividers};
      border-left: none;
      border-right: none;
    }
    .flw__data-table .ReactTable .rt-tbody .rt-td {
      ${spacing('py', 4)}
      color: ${theme.color.general.font.primary};
      font-size: 16px;
      font-weight: 400;
    }
    .flw__data-table .ReactTable .rt-tbody .rt-td .flw__html-component__html-input.flw__component__html-input{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .flw__data-table .ReactTable .rt-tbody .rt-tr-group:first-child .rt-tr {
      border-top: none;
    }
    .flw__data-table .ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
      background: rgba(0,0,0,0.02);
    }
    
    // PAGINATION
    .flw__data-table .ReactTable .-pagination .-pageSizeOptions select {
      color: ${theme.color.link.default};
      font-weight: 700;
      ${getIconBackgroundImage('icn_chevron_down', theme.color.link.default, 20, 20)};
    }
    
    .flw__data-table .ReactTable .pagination-bottom {
      color: ${theme.color.general.font.primary};
      font-size: 16px;
      font-weight: 400;
    }
    .flw__data-table .ReactTable .-pagination .-next, 
    .flw__data-table .ReactTable .-pagination .-previous,
    .flw__data-table .ReactTable .-pagination .-pageSizeOptions select,
    .flw__data-table .ReactTable .-pagination {
      border: none;
    }
    
    .flw__data-table .ReactTable .-pagination .-previous .-btn, 
    .flw__data-table .ReactTable .-pagination .-previous .-btn:not([disabled]), 
    .flw__data-table .ReactTable .-pagination .-previous .-btn[disabled] {
      ${getIconBackgroundImage('icn_arrow_left', theme.color.standard_button.secondary.default.font, 18, 18)};
      background-color: ${theme.color.standard_button.secondary.default.background};
      ${theme.radii.radius12};
      height: 40px;
      width: 40px;
      ${spacing('mr', 2)}
    }
    
    .flw__data-table .ReactTable .-pagination .-next .-btn, 
    .flw__data-table .ReactTable .-pagination .-next .-btn:not([disabled]), 
    .flw__data-table .ReactTable .-pagination .-next .-btn[disabled] {
      ${getIconBackgroundImage('icn_arrow_right', theme.color.standard_button.secondary.default.font, 18, 18)};
      background-color: ${theme.color.standard_button.secondary.default.background};
      ${theme.radii.radius12};
      height: 40px;
      width: 40px;
    }
    .flw-form.flw-form--loading,
    .flw-useDataLoader.flw-useDataLoader--loading.flw-useDataLoader--loadingInline {
      margin: auto;
      ${spacing('mt')}
      width: 72px;
      height: 72px;
      overflow: hidden;
      color: ${theme.color.general.background};
    }
    .flw-useDataLoader--loading .fa-circle-notch {
      color: ${theme.color.progress_and_loading.main};
      width: 72px;
      height: 72px;
    }
    .flw-useDataLoader.flw-useDataLoader--loading.flw-useDataLoader--loadingInline svg path {
      stroke-width: 26px;
      stroke: ${theme.color.general.background};
    }
    .flw-form.flw-form--loading svg path {
      stroke-width: 42px;
      stroke: ${theme.color.general.background};
    }
  `
}